import React from 'react'
import {Pagination} from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

function Paginate({pages, page, keyword='', isAdmin=false}) {
  // keyword is actually the full query string (e.g. ?style=Straight&color=Black)
  const search = typeof keyword === 'string' ? keyword.replace(/^\?/, '') : ''
  const baseParams = new URLSearchParams(search)

  return (
    pages > 1 && (
      <Pagination>
        {[...Array(pages).keys()].map((x) => {
          const params = new URLSearchParams(baseParams.toString())
          params.set('page', x + 1)
          const qs = params.toString()
          const to = !isAdmin
            ? `/?${qs}`
            : `/admin/productlist/?${qs}`
          return (
            <LinkContainer key={x+1} to={to}>
              <Pagination.Item active={x+1 === page}> {x+1}</Pagination.Item>
            </LinkContainer>
          )
        })}
      </Pagination>
    )
  )
}

export default Paginate